import { isNull } from "@ckweb/common/assertate";
import type { GenericMessageObject } from "../types/notifications";

export enum PERSISTENT_TYPES {
  NONE = "NONE",
}

export function isMessageObject(value: unknown): value is GenericMessageObject {
  return typeof value === "object" && !isNull(value) && Object.hasOwn(value, "message");
}
